export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              欢迎投稿、咨询或提出宝贵建议
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                  <i className="ri-mail-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">投稿邮箱</h3>
                <p className="text-xs text-foreground-500">tougao@chigua51.com</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                  <i className="ri-chat-smile-2-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">hezuo@chigua51.com</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                  <i className="ri-customer-service-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">用户反馈</h3>
                <p className="text-xs text-foreground-500">fankui@chigua51.com</p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-background-200/60">
              <p className="text-xs text-foreground-500 text-center leading-relaxed">
                如需投稿或咨询相关事宜，请通过以上邮箱与我们取得联系。我们会在收到邮件后尽快回复。
                同时也欢迎广大吃瓜群众通过官方入口持续关注吃瓜网51最新动态。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}